import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {
  ICompanyMutation,
  IVacancy,
  IVacancyMutation,
} from '@interfaces/ICompany';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompaniesChangesService {
  constructor(private _http: HttpClient) {}

  createCompany(data: ICompanyMutation) {
    const url = `${environment.baseUrl}api/v1/users/companies/`;
    return this._http.post(url, data);
  }

  createVacancy(data: IVacancyMutation): Observable<IVacancy> {
    const url = `${environment.baseUrl}api/v1/vacancies/`;
    return this._http.post<IVacancy>(url, data);
  }

  deleteVacancy(id: number) {
    const url = `${environment.baseUrl}api/v1/vacancies/${id}/`;
    return this._http.delete(url);
  }

  editVacancy(id: number, data: Partial<IVacancyMutation>) {
    const url = `${environment.baseUrl}api/v1/vacancies/${id}/`;
    return this._http.patch(url, data);
  }
}
